export default "__VITE_ASSET__BJdszD$X__"